import { Autocomplete, Checkbox, Chip, TextField } from "@mui/material";

function normalizeOption(option) {
  if (typeof option === "string") {
    return { value: option, label: option };
  }

  return option;
}

function formatCount(value) {
  return new Intl.NumberFormat("en-GB").format(Number(value || 0));
}

export function MultiSelectionAutocomplete({
  label,
  values,
  onChange,
  options,
  placeholder = "Select",
  showCheckboxes = false,
  counts,
  formatOptionLabel,
}) {
  const normalizedOptions = options.map(normalizeOption);
  const selectedOptions = normalizedOptions.filter((option) => values.includes(option.value));
  const getBaseLabel = (option) =>
    typeof formatOptionLabel === "function"
      ? formatOptionLabel(option.value, option)
      : option.label;

  return (
    <Autocomplete
      multiple
      size="small"
      disableCloseOnSelect
      options={normalizedOptions}
      value={selectedOptions}
      onChange={(_, nextOptions) => onChange(nextOptions.map((option) => option.value))}
      getOptionLabel={getBaseLabel}
      isOptionEqualToValue={(option, value) => option.value === value.value}
      renderTags={(tagValue, getTagProps) =>
        tagValue.map((option, index) => (
          <Chip
            {...getTagProps({ index })}
            key={option.value}
            label={getBaseLabel(option)}
            size="small"
          />
        ))
      }
      renderOption={(props, option, { selected }) => (
        <li {...props}>
          {showCheckboxes ? (
            <Checkbox
              size="small"
              checked={selected}
              sx={{ mr: 1, p: 0.5 }}
            />
          ) : null}
          {getBaseLabel(option)}
          {counts?.has(option.value) ? ` (${formatCount(counts.get(option.value))})` : ""}
        </li>
      )}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          placeholder={normalizedOptions.length === 0 ? "No values available" : placeholder}
        />
      )}
    />
  );
}

export function SingleSelectionAutocomplete({
  label,
  value,
  onChange,
  options,
  placeholder = "Select",
}) {
  const normalizedOptions = options.map(normalizeOption);
  const selectedOption = normalizedOptions.find((option) => option.value === value);

  return (
    <Autocomplete
      multiple
      size="small"
      options={normalizedOptions}
      value={selectedOption ? [selectedOption] : []}
      onChange={(_, nextOptions) => onChange(nextOptions.at(-1)?.value || "")}
      getOptionLabel={(option) => option.label}
      isOptionEqualToValue={(option, selected) => option.value === selected.value}
      renderOption={(props, option) => <li {...props}>{option.label}</li>}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          placeholder={normalizedOptions.length === 0 ? "No values available" : placeholder}
        />
      )}
    />
  );
}
